import { ActionPerformed, PushNotificationSchema, Token } from '@capacitor/push-notifications';
import { createAction, props } from '@ngrx/store';

export const registration = createAction('[Push Notifications] Registration');

export const registrationSuccess = createAction(
  '[Push Notifications] Registration Success',
  props<{
    payload: Token;
  }>()
);

export const registrationFailure = createAction(
  '[Push Notifications] Registration Failure',
  props<{
    payload: { error: Error };
  }>()
);

export const notificationReceived = createAction(
  '[Push Notifications] Notification Received',
  props<{
    payload: PushNotificationSchema;
  }>()
);

export const notificationActionPerformed = createAction(
  '[Push Notifications] Notification Action Performed',
  props<{
    payload: ActionPerformed;
  }>()
);

export const sendTestNotification = createAction(
  '[Push Notifications] Send Test Notification',
  props<{
    payload: {
      type?: string;
    };
  }>()
);
